import {
  ROLE_DEVELOPER_UUID,
  ROLE_ORG_ADMIN_UUID,
  ROLE_ORG_PUBLISHER_UUID,
  ROLE_UUID_NAME_MAP,
  ROLE_NAME_USER_MAP,
  USER_TYPE_GLOBAL,
  USER_TYPE_ORG,
} from "../../../constants";
import get from 'lodash/get';
import find from 'lodash/find';

export const getAvailableRoles = (type, intl) => {
    const roles = [
      {
        uuid: ROLE_DEVELOPER_UUID,
        name: intl.getI18nMessage('label.user.role.developers'),
      },
      {
        uuid: ROLE_ORG_ADMIN_UUID,
        name: intl.getI18nMessage('label.user.role.devorgadministrators'),
      },
    ];
    if(type === 'PUBLISHER') {
      roles.push({
          uuid: ROLE_ORG_PUBLISHER_UUID,
          name: intl.getI18nMessage('label.user.role.orgpublishers'),
      });
    }
    return roles;
  };

export const accessArrayToRolesMap = (access = []) => {
  const rolesMap = {};
  access.forEach(roleObj => rolesMap[roleObj.orgUuid] = roleObj.roleUuid);
  return rolesMap;
};

export const rolesMapToAccessArray = (rolesMap = {}) => {
  const access = [];
  Object.keys(rolesMap).forEach(key => access.push({
    orgUuid: key,
    roleUuid: rolesMap[key],
  }));
  return access;
};

export const deduceUserRoleAndAuthorizationType = (access = [], orgUUID, userType) => {
  let userRole, authznType;
  if (userType === USER_TYPE_GLOBAL) {
    const userRoleUUID = get(access[0], 'roleUuid', '');
    userRole = ROLE_NAME_USER_MAP[ROLE_UUID_NAME_MAP[userRoleUUID]];
    authznType = get(access[0], 'authznType', '');
  } else {
    let accessObject = find(access, item => item.orgUuid === orgUUID);
    // orgUUID would be empty if admin is editing org user,
    // in that case accessObject would be empty
    // we can just take first access object to get info about authznType.
    // userRole is ignored by add/edit tab as the user has to use org access tab
    if (!accessObject) {
      accessObject = (access.length === 0) ? {} : access[0];
    }
    userRole = ROLE_NAME_USER_MAP[ROLE_UUID_NAME_MAP[get(accessObject, 'roleUuid', '')]] || '';
    authznType = get(accessObject, 'authznType', '');
  }
  return {
    userRole,
    authznType,
  };
};

export const deduceUserType = (access = []) => {
  const userType = '';
  if (access.length > 1) {
    return USER_TYPE_ORG;
  } else if (access.length === 1) {
    if (get(access[0], 'orgUuid')) {
      return USER_TYPE_ORG;
    } else {
      return USER_TYPE_GLOBAL;
    }
  }
  return userType;
};
